module.exports = __webpack_public_path__ + "4ab73acf21db07b8a4b57c692156003d.svg";